import Campaign from 'containers/Campaign';
import Administration from 'containers/Administration';
import NewCampaign2 from 'containers/NewCampaign2';
import Favourite from 'containers/Favourite';

export default [
  {
    name: 'newCampaignHeader',
    component: NewCampaign2,
    path: '/new-campaign',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/out',
  },
  {
    name: 'campaigns',
    component: Campaign,
    path: '/campaigns',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/out',
  },
  {
    name: 'favourites',
    component: Favourite,
    path: '/favourites',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/out',
  },
  {
    name: 'administrator',
    component: Administration,
    path: '/administration',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/out',
  },
];
